import { ArrayHelper } from 'lib_ts/classes/array.helper';
import { MiscHelper } from 'lib_ts/classes/misc.helper';
import { IOption } from 'lib_ts/interfaces/common/i-option';

export const MIN_SPEED_MPH = 50;

// 100%...70% in 5% decrements
export const SCALING_OPTIONS = ArrayHelper.getIntegerOptions(0, 6)
  // descending order (100% first)
  .sort((a, b) => (parseInt(a.value) > parseInt(b.value) ? -1 : 1))
  .map((m) => {
    // e.g. 0, 5, 10, ... 30
    const delta = parseInt(m.value) * 5;
    const value = 70 + delta;

    const o: IOption = {
      // e.g. 70%
      label: `${value}%`,
      // e.g. "0.7"
      value: (value / 100).toString(),
    };

    return o;
  });

const isMeanUsed = true;

export const AVG_METHOD = isMeanUsed
  ? {
      label: 'tr.mean',
      fn: MiscHelper.getMeanObject,
    }
  : {
      label: 'tr.median',
      fn: MiscHelper.getMedianObject,
    };

export const DECIMALS_SPEED = 1;
export const DECIMALS_SPIN = 0;
export const DECIMALS_BREAKS = 1;

export enum PitchDataMode {
  GameData,
  PitchList,
}
